// Import model
import { FilterContactNoteRequest } from '../models/FilterContactNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactNoteCondition } from '../models/ContactNoteCondition';
import { ContactNoteFields } from '../models/ContactNoteFields';
import { ContactNoteIndexedFields } from '../models/ContactNoteIndexedFields';

// Import dependency serializers (for complex types)
import { ContactNoteConditionSerializer } from './ContactNoteConditionSerializer';
import { ContactNoteFieldsSerializer } from './ContactNoteFieldsSerializer';
import { ContactNoteIndexedFieldsSerializer } from './ContactNoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterContactNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterContactNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterContactNoteRequest instance
   */
  static deserialize(json: string): FilterContactNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterContactNoteRequest instance
   */
  static fromObject(obj: any): FilterContactNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterContactNoteRequest');
    }


    const instance: FilterContactNoteRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ContactNoteIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ContactNoteFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ContactNoteConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterContactNoteRequest instances
   */
  static deserializeArray(json: string): FilterContactNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterContactNoteRequest instance to a JSON string
   */
  static serialize(instance: FilterContactNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterContactNoteRequest instance to a plain object
   */
  static toObject(instance: FilterContactNoteRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ContactNoteConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterContactNoteRequest instances to a JSON string
   */
  static serializeArray(instances: FilterContactNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
